import { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import STSwiper from "../../assets/styles/molecules/swiper.module.scss";
import STCategoryCardList from "../../assets/styles/organisms/categoryCardList.module.scss";
import { SiteContext } from "../../providers/SiteProvider";
import { routes } from "../../router/Router";
import TApiResult from "../../types/api/TApiResult";
import { categorySummary } from "../../types/categorySummary";
import {
  TApiCategoriesResult,
  fetchCategories,
} from "../../utils/api/fetchCategories";
import CategoryCard from "../molecules/CategoryCard";
import CategoryCardNew from "../molecules/CategoryCardNew";
import InformationList from "./InformationList";

const CategoryCardList: React.FC = () => {
  const [categories, setCategories] = useState<categorySummary[]>([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 799);
  const [activeId, setActiveId] = useState<number>(-1);
  const [categoryName, setCategoryName] = useState<string>("");
  const swiperRef = useRef<any>(null);
  const [linkUrl, setLinkUrl] = useState<string>("");
  const site = useContext(SiteContext);
  const mainColor = site.mainColor;

  const scrollToActiveCategory = (index: number) => {
    if (swiperRef.current) {
      // find element with index
      const activeSlideEl = swiperRef.current.slides[index];
      const activeSlideRect = activeSlideEl.getBoundingClientRect();
      const swiperEl = swiperRef.current.wrapperEl;
      const swiperRect = swiperEl.getBoundingClientRect();

      // calculate the scroll position
      const scrollLeft =
        swiperRect.left -
        activeSlideRect.left +
        (swiperRect.width - activeSlideRect.width) / 2;

      swiperRef.current.translateTo(scrollLeft, 500);
    }
  };

  const handleChangeCategory = (activeId: number, index: number) => {
    setActiveId(activeId);
    
    const currentCategory = categories.find((cate) => cate.id === activeId);
    if (currentCategory) {
      setCategoryName(currentCategory?.name);
      setLinkUrl(currentCategory?.linkUrl);
    }
    
    scrollToActiveCategory(index);
  };

  const updateMedia = () => {
    setIsMobile(window.innerWidth < 799);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => {
      window.removeEventListener("resize", updateMedia);
    };
  }, []);

  useEffect(() => {
    fetchCategories(true).then((res: TApiResult & TApiCategoriesResult) => {
      if (!res.isSuccess || !res.result) {
        return;
      }

      const newCategories = res.result.map((res) => {
        return {
          id: res.id,
          name: res.name,
          linkUrl: res.slug
            ? `${routes.informations.path}?category_slug=${res.slug}`
            : `${routes.informations.path}?category=${res.id}`,
          imageUrl: res.image_url,
        };
      });
      newCategories.unshift({
        id: -1,
        name: "すべて",
        linkUrl: "",
        imageUrl: "",
      });
      setCategories(newCategories);
    });
  }, []);

  const renderCategories = () => {
    const mobileMinPerView = 2.5;
    const pcMinPerView = 5.5;
    // 全てを除くカテゴリがない場合は表示させない
    if (categories.length > 1) {
      return (
        <div className={STCategoryCardList.categorySwiperContainer}>
          <Swiper
            spaceBetween={2}
            slidesPerView={
              isMobile
                ? categories.length <= 2
                  ? categories.length
                  : mobileMinPerView
                : categories.length <= 5
                ? categories.length
                : pcMinPerView
            }
            className={STCategoryCardList.categorySwiper}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {categories.map((category, index) => (
              <SwiperSlide
                className={STCategoryCardList.categorySlide}
                key={category.id}
              >
                <CategoryCardNew
                  title={category.name}
                  isActive={category.id === activeId}
                  handleChangeCategory={(activeId) =>
                    handleChangeCategory(activeId, index)
                  }
                  id={category.id}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      );
    }
    return null;
  };

  const SwiperComponent: React.FC = () => {
    return (
      <div className={STSwiper.swiper_container}>
        <Swiper
          className={STSwiper.category_swiper}
          spaceBetween={8}
          slidesPerView={2.8}
          initialSlide={0}
        >
          {categories.map((category) => {
            return (
              <SwiperSlide
                className={STSwiper.slide_new}
                key={`slide-${category.id}`}
              >
                <CategoryCard {...category} />
              </SwiperSlide>
            );
          })}
          <div className={STSwiper.banner_pagination}></div>
        </Swiper>
      </div>
    );
  };
  return (
    <>
      {categories.length > 0 && (
        <>
          <section className={STCategoryCardList.category_card_list}>
            <div className={STCategoryCardList.category_card_list_title_new}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  stroke={mainColor}
                  stroke-width="6"
                />
              </svg>
              <h3>お役立ち記事</h3>
            </div>
            <div
              className={`${STCategoryCardList.category_card_list_wrap} ${STCategoryCardList.category_card_list_wrap_new}`}
            >
              {renderCategories()}
            </div>
          </section>
          <InformationList categoryName={categoryName} activeId={activeId} url={linkUrl} />
        </>
      )}
    </>
  );
};

export default CategoryCardList;
